// extracted by mini-css-extract-plugin
export default {"textDivider":"TextDivider_textDivider__URX1b","text":"TextDivider_text__C7oxp"};